import { hiddenFeature } from "./utilitiesmodule";

export const OneSignalSetup={
	OneSignal: null,

	init: function() {
		window.OneSignalDeferred=window.OneSignalDeferred||[];

		window.OneSignalDeferred.push(async (OneSignal) => {
			this.OneSignal=OneSignal;
			await OneSignal.init({
				appId: hiddenFeature()? "20b3d3a8-41b4-4cef-b322-aef386e9448b":"0ac87776-b923-41c4-a5cb-131a8e1f649c",
				safari_web_id: hiddenFeature()? "web.onesignal.auto.641afdf7-f4bf-4e2a-9c3a-de381580c8ca":"web.onesignal.auto.40e188d7-5f7a-4af3-8ac5-05427adc97a7",
				notifyButton: { enable: true },
				allowLocalhostAsSecureOrigin: true,
			});

			console.log("Opted-in:", OneSignal.User.PushSubscription.optedIn);
			this.addListeners();
		});

	},

	addListeners: function() {
		this.OneSignal.User.addEventListener("change", (event) => {
			console.log("User change:", event);
		});

		this.OneSignal.User.PushSubscription.addEventListener("change", (event) => {
			console.log("Push subscription change:", event);
		});

		this.OneSignal.Notifications.addEventListener("permissionChange", (permission) => {
			console.log("Permission changed:", permission);
		});

		this.OneSignal.Notifications.addEventListener("foregroundWillDisplay", (event) => {
			console.log("Notification will display:", event);
		});

		this.OneSignal.Notifications.addEventListener("click", (event) => {
			console.log("Notification clicked:", event);
		});
	},

	addEventListener_Change: async function(func) {

		//test
		this.OneSignal.User.PushSubscription.addEventListener("change", func);

		console.log("Prima:", {
			optedIn: this.OneSignal.User.PushSubscription.optedIn,
			id: this.OneSignal.User.PushSubscription.id,
			token: this.OneSignal.User.PushSubscription.token,
		});

		// Disiscrivi
		await this.OneSignal.User.PushSubscription.optOut();

		// Aspetta un attimo
		setTimeout(async () => {
			// Reiscrivi
			await this.OneSignal.User.PushSubscription.optIn();

			console.log("Dopo:", {
				optedIn: this.OneSignal.User.PushSubscription.optedIn,
				id: this.OneSignal.User.PushSubscription.id,
				token: this.OneSignal.User.PushSubscription.token,
			});
		}, 2000);
	},

	subscribeUser: async function(userID, lang) {


		//16/03/2026 - Veronica : Nuova comfigurazione di OneSignal da ChatGPT

		try {
			if (!this.OneSignal.User.PushSubscription.optedIn)
				return; const optedIn=this.OneSignal.User.PushSubscription.optedIn;
			console.log("Opted-in:", optedIn);
			console.log("Permission:", this.OneSignal.Notifications.permission);
			console.log("Subscription ID:", this.OneSignal.User.PushSubscription.id);
			console.log("Token:", this.OneSignal.User.PushSubscription.token);
			console.log("External ID prima del login:", this.OneSignal.User.externalId);

			if (optedIn) {
				await this.OneSignal.login(String(userID));
				this.OneSignal.User.setLanguage(lang);

				console.log("OneSignal login ok");
				console.log("External ID dopo login:", this.OneSignal.User.externalId);
			}
		} catch (e) {
			console.error("OneSignal login failed:", e);
		}
	},



	registerServiceWorker: function() {
		if (!('serviceWorker' in navigator))
			return;

		navigator.serviceWorker.getRegistration().then(registration => {

			if (!registration||registration.active.scriptURL.indexOf('service-worker.js')===-1) {
				let serviceWorkerPath=hiddenFeature()
					? '/assets/js/localhost_service-worker.js'
					:'/assets/js/service-worker.js'

				navigator.serviceWorker.register(serviceWorkerPath)
					.then(registration => {
						console.info('Service Worker registrato con successo:', registration);
					})
					.catch(error => {
						console.writeError('Errore nella registrazione del Service Worker:', error);
					}); // Registra solo se non esiste
			} else {
				console.info('Service Worker già presente:', registration);
			}
		});

	},

	pushIsActive: function() {
		if (!this.OneSignal)
			return false;
		return this.OneSignal.User.PushSubscription.optedIn;

	},

	handleWebPushChange: function() {

		if (this.OneSignal&&!this.OneSignal.User.PushSubscription.optedIn) {
			this.OneSignal.Notifications.requestPermission();
		}

	},

	logout: async function() {

		if (!this.OneSignal.User.PushSubscription.optedIn)
			return;

		await OneSignal.logout();
	}
} 